import { render, staticRenderFns } from "./CompanyPlans.vue?vue&type=template&id=5d2dc15e&scoped=true"
import script from "./CompanyPlans.vue?vue&type=script&lang=js"
export * from "./CompanyPlans.vue?vue&type=script&lang=js"
import style0 from "./CompanyPlans.vue?vue&type=style&index=0&id=5d2dc15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2dc15e",
  null
  
)

export default component.exports